import React from "react";
import { useTranslation } from "react-i18next";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  ResourcesInfoContainer,
  ResourcesSingleFrameContainter,
  ResourcesTitleContainter,
} from "./Resources.styles";
import { ResourcesData } from "./ResourcesData";

export const Resources = (): React.ReactElement => {
  const { deviceType } = useDeviceHook();
  const { t } = useTranslation();

  return (
    <ResourcesSingleFrameContainter>
      <ResourcesTitleContainter>
        {GetTypographyContent({
          content: t("resources.title"),
          isBold: true,
          isCaps: true,
          size: "large",
          textColor: "greyMedium",
        })}
      </ResourcesTitleContainter>
      <ResourcesInfoContainer deviceType={deviceType}>
        {ResourcesData(t)}
      </ResourcesInfoContainer>
    </ResourcesSingleFrameContainter>
  );
};
